import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/IdentitasBayiBaruLahir";

interface ApgarScore {
  frekuensi_jantung: number | null;
  usaha_bernafas: number | null;
  tonus_otot: number | null;
  iritabilitas_refleks: number | null;
  warna_kulit: number | null;
  jumlah: number | null;
}

interface RiwayatObstetriItem {
  tahun: string;
  jenis_persalinan: string;
  berat_bayi: string;
  jenis_kelamin: string;
  keadaan_bayi: string;
  keadaan_kehamilan: string;
  lain_lain: string;
}

interface Data {
  id: number;
  register_id: number;
  pasien_rm: string;
  unit_id: string;

  nama_ibu: string;
  umur_ibu: number;
  pekerjaan_ibu: string;
  pekerjaan_ibu_lainnya: string;
  pendidikan_ibu: string;
  agama_ibu: string;

  nama_ayah: string;
  umur_ayah: number;
  pekerjaan_ayah: string;
  pekerjaan_ayah_lainnya: string;
  pendidikan_ayah: string;
  agama_ayah: string;

  nama_bayi: string;
  tanggal_lahir: string;
  jenis_kelamin: string;
  jam_kelahiran: string;
  jenis_kelahiran: string;
  status_kelahiran: string;
  alamat: string;

  berat_badan: number;
  panjang_badan: number;
  lingkar_kepala: number;
  lingkar_dada: number;
  lingkar_lengan_atas: number;
  uub_transversal: number;
  uub_sagital: number;

  apgar_1_menit: ApgarScore;
  apgar_5_menit: ApgarScore;
  apgar_2_jam: ApgarScore;

  gravida: number | null;
  paritas: number | null;
  abortus: number | null;
  anak_hidup: number | null;
  umur_kehamilan: string;
  hpm: string;
  hpl: string;
  anc_jumlah: number;
  anc_tempat: string;
  anc_keteraturan: string;
  anc_sejak_minggu: number;
  penyakit_komplikasi: string;
  riwayat_pengobatan: string;
  hb_terakhir: number;
  golongan_darah: string;

  tindakan_pada_ibu: string;

  riwayat_obstetri: RiwayatObstetriItem[];

  persalinan_di: string;
  ditolong_oleh: string;
  cara_persalinan: string;
  atas_indikasi: string;
  lama_persalinan: { kala_1: string; kala_2: string; kala_3: string; jumlah: string };
  ketuban_pecah: { tanggal: string; jam: string; warna: string; bau: string; keterangan: string };
  plasenta: { berat: string; ukuran: string };
  perdarahan: { kala_1: string; kala_2: string; kala_3: string; kala_4: string; jumlah: string };

  cap_kaki: string;
  cap_kaki_url?: string;

  dokter_id: string;
  perawat_id: string;
  signed_at: string;
  user_id: string;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "identitas-bayi-baru-lahir"
})
class IdentitasBayiBaruLahirStore extends VuexModule {
  loading = false;
  record: Data = null;
  isAnyUnsavedChange = false;

  @Mutation
  SET_RECORD(val) {
    this.record = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.record = null;
    this.isAnyUnsavedChange = false;
    this.loading = false;
  }

  @Mutation
  SET_IS_ANY_UNSAVED_CHANGE(val) {
    this.isAnyUnsavedChange = val;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RECORD(response.data?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }

  @Action({ rawError: true })
  setIsAnyUnsavedChange(val): void {
    this.SET_IS_ANY_UNSAVED_CHANGE(val);
  }
}

export default getModule(IdentitasBayiBaruLahirStore);
